import React from "react";
import { Container, Header, Table, Button, Segment, Message, Label } from "semantic-ui-react";

const formatDate = d => {
  if (!d) return "";
  try {
    return new Date(d).toLocaleString();
  } catch (e) {
    return String(d);
  }
};

const UserManagement = ({
  joinRequests,
  members,
  onApprove,
  onReject,
  onToggleUseYn,
  onDelete,
  isApprovalLoading,
  isUseYnLoading,
  isDeleteLoading,
  errorMessage
}) => {
  return (
    <Container style={{ paddingTop: "5em", paddingBottom: "3em" }}>
      <Header as="h2">회원관리</Header>

      {errorMessage ? (
        <Message negative>
          <Message.Header>처리 실패</Message.Header>
          <p>{errorMessage}</p>
        </Message>
      ) : null}

      <Segment loading={isApprovalLoading}>
        <Header as="h3">가입 신청</Header>
        {joinRequests.length === 0 ? (
          <p>대기중인 가입 신청이 없습니다.</p>
        ) : (
          <Table celled compact>
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell>사번</Table.HeaderCell>
                <Table.HeaderCell>아이디</Table.HeaderCell>
                <Table.HeaderCell>이름</Table.HeaderCell>
                <Table.HeaderCell>신청일</Table.HeaderCell>
                <Table.HeaderCell textAlign="center">처리</Table.HeaderCell>
              </Table.Row>
            </Table.Header>
            <Table.Body>
              {joinRequests.map(u => (
                <Table.Row key={u.mbrId}>
                  <Table.Cell>{u.empNum}</Table.Cell>
                  <Table.Cell>{u.mbrId}</Table.Cell>
                  <Table.Cell>{u.mbrName}</Table.Cell>
                  <Table.Cell>{formatDate(u.regDt)}</Table.Cell>
                  <Table.Cell textAlign="center">
                    <Button
                      primary
                      size="small"
                      disabled={isApprovalLoading}
                      onClick={() => onApprove(u.mbrId)}
                    >
                      승인
                    </Button>
                    <Button
                      negative
                      size="small"
                      disabled={isApprovalLoading}
                      onClick={() => onReject(u.mbrId)}
                    >
                      반려
                    </Button>
                  </Table.Cell>
                </Table.Row>
              ))}
            </Table.Body>
          </Table>
        )}
      </Segment>

      <Segment loading={isUseYnLoading || isDeleteLoading}>
        <Header as="h3">전체 회원</Header>
        {members.length === 0 ? (
          <p>등록된 회원이 없습니다.</p>
        ) : (
          <Table celled compact>
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell>사번</Table.HeaderCell>
                <Table.HeaderCell>아이디</Table.HeaderCell>
                <Table.HeaderCell>이름</Table.HeaderCell>
                <Table.HeaderCell>가입상태</Table.HeaderCell>
                <Table.HeaderCell>활성</Table.HeaderCell>
                <Table.HeaderCell textAlign="center">처리</Table.HeaderCell>
              </Table.Row>
            </Table.Header>
            <Table.Body>
              {members.map(u => {
                const isActive = u.useYn !== "N";
                return (
                  <Table.Row
                    key={u.mbrId}
                    style={{ color: isActive ? undefined : "#999" }}
                  >
                    <Table.Cell>{u.empNum}</Table.Cell>
                    <Table.Cell>{u.mbrId}</Table.Cell>
                    <Table.Cell>{u.mbrName}</Table.Cell>
                    <Table.Cell>{u.status}</Table.Cell>
                    <Table.Cell>
                      {isActive ? (
                        <Label color="green" size="small">활성</Label>
                      ) : (
                        <Label size="small">비활성</Label>
                      )}
                    </Table.Cell>
                    <Table.Cell textAlign="center">
                      <Button
                        size="small"
                        color={isActive ? "grey" : "blue"}
                        disabled={isUseYnLoading}
                        onClick={() =>
                          onToggleUseYn(u.mbrId, isActive ? "N" : "Y")
                        }
                      >
                        {isActive ? "비활성화" : "활성화"}
                      </Button>
                      <Button
                        size="small"
                        negative
                        basic
                        disabled={isDeleteLoading}
                        onClick={() => onDelete(u.mbrId, u.mbrName)}
                        style={{ marginLeft: 4 }}
                      >
                        삭제
                      </Button>
                    </Table.Cell>
                  </Table.Row>
                );
              })}
            </Table.Body>
          </Table>
        )}
      </Segment>
    </Container>
  );
};

export default UserManagement;
